
export const ENV_VARIABLES = {
	PUBLIC_INLANG_SDK_SENTRY_DSN: undefined,
	SDK_VERSION: "2.9.1",
}
